/*
 *   File : view-apis.js
 *   Author : https://evoqins.com
 *   Description : View apis modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';
import { useNavigate } from 'react-router-dom';

// custom components
import { PrimaryButton } from '../Buttons';
import { Icon } from '../Icon';
import { CustomDataTable } from '../DataTable';
import { Chip, EmptyScreen } from '../Others';

const OPS_VIEW_APIS_SESSION_KEY = 'ops_view_apis_restore';

const ViewApisModal = (props) => {

    const { data, handleClose } = props;

    const navigate = useNavigate();

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-apis-modal-close");
        button.click();
        handleClose();
    };

    const TABLE_COLUMN = [
        {
            name: 'Name',
            cell: row => <>
                {row.name}
            </>,
            width: "280px",
        },
        {
            name: 'Success/ Failed',
            cell: row =>
                row.api_status !== null ? <Chip label={row.api_status}
                    className={row.api_status?.toLowerCase() === "success" ? "e-bg-green-crayola" : "e-bg-maximum-red "} /> : "-",
            width: "170px",
        },
        {
            name: 'Failure Type',
            selector: row => row.failure_type || "-",
            width: "220px"
        },
        {
            name: 'Timestamp',
            selector: row => row.created_at || "-",
            width: "190px"
        },
        {
            name: 'Action',
            selector: row => "-",
            cell: row => <span className='e-text-blue-violet text-truncate text-decoration-hover-underline cursor-pointer e-font-weight-500 '
                onClick={() => {
                    try {
                        sessionStorage.setItem(
                            OPS_VIEW_APIS_SESSION_KEY,
                            JSON.stringify({ api_data: data, tab_index: 2 })
                        );
                    } catch (_) {
                        /* ignore quota / private mode */
                    }
                    navigate('/ops/api-history', {
                        state: {
                            id: row.id,
                            tab_index: 2,
                            api_data: data
                        }
                    })
                    var button = document.getElementById("view-apis-modal-close");
                    button.click();

                    // _handleCloseModal();
                }}>
                View history
            </span>,
            width: "120px"
        },
    ];

    return (
        <div className="modal fade "
            id="view-apis-modal"
            // data-api-data={data ?? ''}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="ViewApisModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable border-radius-28`}>
                <span id='view-apis-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content border-radius-28  border-0 `}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center pt-4 px-4 pb-2">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                             {data?.name || ""}
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={` modal-body px-0 py-0`}>
                        <div className='e-data-table-wrapper-default-updated pt-3'>
                            {data?.apis?.length !== 0 ?
                                <CustomDataTable columns={TABLE_COLUMN}
                                    data={data?.apis}
                                    pagination={false}
                                    // paginationPerPage={ITEMS_PER_PAGE}
                                    paginationDefaultPage={1}
                                    // paginationTotalRows={props.data.length}
                                    // lastPage={1}
                                    onChangePage={() => { }}
                                />
                                :
                                <EmptyScreen width={120} height={120}
                                    image={require('../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found' />}
                        </div>
                    </div>

                    {/* Modal footer  */}
                    <div className={`px-4 pt-3 pb-4 modal-footer border-0 `}>
                        <PrimaryButton name="Ok"
                            paddingBlock='padding-12px-tb padding-52px-lr'
                            onClick={_handleCloseModal} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ViewApisModal;